import { IacManagementGroupBy } from "./types";

export const IAC_MANAGEMENT_GROUP_BY_OPTIONS = [
  { value: IacManagementGroupBy.Stack, label: "Stack" },
  { value: IacManagementGroupBy.Provider, label: "Provider" },
  { value: IacManagementGroupBy.Type, label: "Type" },
];

export const RESOURCE_DRAWER_TARGET_WHITE_LIST = "data-resource-drawer-target-white-list";
